
	import Vue from "vue"
	import Component from "vue-class-component"
	import { Watch } from "vue-property-decorator"
	import { namespace, State } from "vuex-class"
	import Page from "custom/Page.vue"
	import ContentHeader from "custom/ContentHeader.vue"
	import MessageBox from "custom/MessageBox.vue"
	import { Message } from "store/messages/types"
	import { StoreMutation } from "@lib/types/vuex"
	import Secured from "utils/security/Secured"
	import { session } from "api/index"

	const messages = namespace("messages")

	@Secured(session)
	@Component({
		components: {
			MessageBox,
			Page,
			ContentHeader
		}
	})
	export default class Inbox extends Vue {
		@messages.State messages!: Array<Message>
		@messages.Mutation readMessage!: StoreMutation<Message>
		@State selectedMessage!: Message

		selected: Message | null = null

		@Watch("selectedMessage")
		selectMessage(message?: Message): void {
			this.selected = this.selectedMessage
			if (!message) {
				return
			}

			const item = this.messages.find(m => m.id === message.id)
			if (!item) {
				return
			}
		}
	}
